

import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
// import iconcoppy from "../../assets/iconcoppy.png"
import { PiCopySimple } from "react-icons/pi";
import toast from "react-hot-toast";

export default function PopUpPayLoan({
  open,
  onClose,
  onSubmit,
  installmentData,
  memberData,
  loanData,
}) {
  // State
  const [formData, setFormData] = useState();
  const [disableButton, setDisableButton] = useState(false);
  
  const baseUrl = window.location.origin;

  const installmentLink = `${baseUrl}/member-payment/${installmentData?._id || "unknown"}`;

  const handleCopy = () => {
    navigator.clipboard
      .writeText(installmentLink)
      .then(() => {
        // Provide feedback to the user
        const copyText = document.querySelector(".copy-text"); // Fix class name typo
        if (copyText) {
          copyText.textContent = "Copied!";
          setTimeout(() => {
            copyText.textContent = "Copy";
          }, 2000);
        }
        // Show success toast
        console.log("Copied to clipboard: ", installmentLink);
        toast.success("ສໍາເນົາສໍາເລັດ !");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        toast.error("ສໍາເນົາຜິດພາດ !");
      });
  };

  // useEffect to set initial form data
  useEffect(() => {
    if (installmentData) {
      setFormData(installmentData);
    }
  }, [installmentData]);

  return (
    <Modal show={open} onHide={onClose} backdrop="static" size="md">
      <div className="modal-header">
        <div>
          <Modal.Header
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 700,
            }}
          >
            ປ້ອນຂໍ້ມູນຊຳລະເງິນ
          </Modal.Header>
        </div>
        <div
          className="copy-container"
          style={{ display: "flex", alignItems: "center", gap: 5 }}
        >
           <span onClick={handleCopy}>
            <PiCopySimple size={40} style={{ cursor: "pointer" }} color="blue"/>
           </span>
          <span
            className="coppy-text"
            style={{ cursor: "pointer" }}
            // onClick={handleCopy}
          >
            Copy
          </span>
        </div>
      </div>

      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ງວດທີ</Form.Label>
          <Form.Control disabled value={formData?.installmentNoteNo} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຊື່ບັນຊີ</Form.Label>
          <Form.Control disabled value={memberData?.fullName} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນເງິນຕົ້ນ (ກີບ)</Form.Label>
          <Form.Control
            disabled={loanData?.loanType !== "DECREASE_INTEREST"}
            value={formData?.principalAmount || ""}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ດອກເບ້ຍ (ກີບ)</Form.Label>
          <Form.Control disabled value={formData?.interestRateAmount || ""} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຄ່າປັບໄໝ (ກີບ)</Form.Label>
          <Form.Control disabled value={formData?.lateFeesAmount || ""} />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 30, marginTop:-40 }}>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={() => {
              onClose();
              setFormData();
            }}
          >
            ຍົກເລີກ
          </Button>
          <Button
            style={{ flex: 1 }}
            disabled={disableButton}
            onClick={() => {
              setDisableButton(true);
              onSubmit(installmentData?._id, {
                ...formData,
                installmentStatus: "SUCCESS",
              })
                .then(() => {
                  setDisableButton(false);
                  setFormData();
                  onClose();
                })
                .catch(() => {
                  setDisableButton(false);
                  onClose();
                });
            }}
          >
            ຢືນຢັນ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}